import React, { useEffect } from 'react';
import AiAlerts from '@components/ai-alerts';
import usePageTitle from '@src/hooks/usePageTitle';
import { Wrapper } from './styled';
import { buildDashboardStore } from '@src/atoms/utils';
import { Provider } from 'jotai';
import apptracker from '@src/utils/sensor/apptracker';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { OPEN_AI_ALERT_SUMMARY } from '@src/utils/sensor/track';

const defaultStore = buildDashboardStore();

const AiAlertsDashboard = (props) => {
  const { store = defaultStore } = props;

  usePageTitle({ text: 'AI Alerts' });

  useEffect(() => {
    apptracker(OPEN_AI_ALERT_SUMMARY, {
      product: CURRENT_PRODUCT_MODE,
    });
  }, []);

  return (
    <Provider store={store}>
      <Wrapper>
        <AiAlerts {...props} />
      </Wrapper>
    </Provider>
  );
};

export default AiAlertsDashboard;
